export default "__VITE_ASSET__BHWPBMF4__"